/* eslint-disable complexity */
import { css } from 'styled-components';
import { pxToRem, fontSize, fontSizeSmall } from '@fil-react-mixins/styled';

import { Props } from './BaseButton';

export default css<Props>`
  ${({ block, small, fullWidth, icon, expanded, dark, theme: { button } }) => css`
    box-sizing: border-box;
    margin: 0 0 1rem;
    padding: ${pxToRem(11)} ${pxToRem(19)};
    cursor: pointer;
    transition: background-color 0.15s ease-out, color 0.15s ease-out, border-color 0.15s ease-out;
    white-space: nowrap;
    border-radius: 0;
    border: ${pxToRem(1)} solid ${button.borderColor};
    text-align: center;
    text-decoration: none;
    color: inherit;
    ${fontSize}

    &[disabled],
    &:disabled {
      cursor: not-allowed;
      opacity: 1;
      border-color: transparent;
    }

    &.focus-visible {
      outline-offset: ${pxToRem(1)};
    }

    > .fil-icon-wrapper {
      line-height: 1;

      &:first-child {
        margin-right: 0.5rem;
      }

      &:last-child {
        margin-left: 0.5rem;
      }

      &:only-child {
        margin: 0;
      }
    }

    ${block &&
    css`
      display: block;
    `}

    ${small &&
    css`
      ${fontSizeSmall}
      padding: ${pxToRem(7)} ${pxToRem(19)};
    `}


  ${fullWidth &&
    css`
      width: 100%;
      max-width: ${pxToRem(280)};
    `}

  ${icon &&
    css`
      padding: 0;
      margin: 0;
      background: transparent;
      border: none;
      font-size: 0;
      line-height: 1;

      &.focus-visible {
        outline-offset: 0;
      }

      && {
        font-size: 0;
        line-height: 1;
      }
    `}


  ${expanded &&
    css`
      display: block;
      width: 100%;
      margin-right: 0;
      margin-left: 0;
    `}

  ${dark &&
    css`
      & {
        background-color: ${button.darkBGColor};

        &&:hover {
          opacity: 0.9;
          background-color: ${button.darkBGColorHover};
        }

        &&:focus {
          opacity: 0.9;
          background-color: ${button.darkBGColorFocus};
        }

        &&:active {
          opacity: 0.8;
          background-color: ${button.darkBGColorActive};
        }

        &&[disabled],
        &&:disabled {
          opacity: 0.6;
        }
      }
    `}
  `}
`;
